/* import __COLOCATED_TEMPLATE__ from './dashboard-loader.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import lottie from 'lottie-web';
import clsx from 'clsx';

const CLASS_NAME = 'SH-c-dashboard-loader';
const ANIMATION_PATH = '/ember/assets/lottie/dashboard-loader.json';

class DashboardLoader extends Component {
  @tracked loadingAnimation = null;

  willDestroy() {
    super.willDestroy();

    this.loadingAnimation?.destroy();
  }

  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
    );
  }

  get className() {
    return CLASS_NAME;
  }

  @action
  loadAnimation(elementId) {
    this.loadingAnimation = lottie.loadAnimation({
      container: document.getElementById(elementId),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: ANIMATION_PATH,
      rendererSettings: {
        progressiveLoad: true,
      },
    });

    this.args.onPlayAnimation?.();
  }
}

export default DashboardLoader;
